import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const chatKonvAdapter = createEntityAdapter({})

const initialState = chatKonvAdapter.getInitialState()

export const chatKonvApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getChatKonv: builder.query({
            query: () => ({
                url: '/chatKonv',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedprompts = responseData.map(prompt => {
                    prompt.id = prompt._id
                    return prompt
                });
                return chatKonvAdapter.setAll(initialState, loadedprompts)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'chatKonv', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'chatKonv', id }))
                    ]
                } else return [{ type: 'chatKonv', id: 'LIST' }]
            }
        }),
        // getOneprompt: builder.query({     //Uzima iz kesha ako ima prompta
        //     query: (id) => ({
        //         url: `/prompts/${id}`,
        //         validateStatus: (response, result) => {
        //             return response.status === 200 && !result.isError;
        //         },
        //     }),
        //     transformResponse: responseData => {
        //         const prompt = { ...responseData, id: responseData._id };
        //         return prompt;
        //     },
        //     providesTags: (result, error, arg) => {
        //         return result
        //             ? [{ type: 'prompt', id: result.id }]
        //             : [];
        //     }
        // }),
        //
        // getAllpromptNames: builder.query({
        //     query: () => ({
        //         url: '/prompts/names',
        //         validateStatus: (response, result) => {
        //             return response.status === 200 && !result.isError
        //         },
        //     }),
        // }),
        // getpromptOrganizacijeByJmbg: builder.query({
        //     query: (jmbg) => ({
        //         url: `/prompts/${jmbg}`,
        //         validateStatus: (response, result) => {
        //             return response.status === 200 && !result.isError;
        //         },
        //     }),
        //     transformResponse: (responseData) => {
        //         const loadedData = responseData.map(item => {
        //             item.id = item._id;
        //             return item;
        //         });
        //         return chatKonvAdapter.setAll(initialState, loadedData);
        //     },
        //     providesTags: (result, error, arg) => {
        //         if (result?.ids) {
        //             return [
        //                 { type: 'Organizacija', id: 'LIST' },
        //                 ...result.ids.map(id => ({ type: 'Organizacija', id })),
        //             ];
        //         } else return [{ type: 'Organizacija', id: 'LIST' }];
        //     },
        // }),
        // addNewprompt: builder.mutation({
        //     query: initialpromptData => ({
        //         url: '/prompts',
        //         method: 'POST',
        //         body: {
        //             ...initialpromptData,
        //         }
        //     }),
        //     invalidatesTags: [
        //         { type: 'prompt', id: "LIST" }
        //     ]
        // }),
        // updateprompt: builder.mutation({
        //     query: initialpromptData => ({
        //         url: '/prompts',
        //         method: 'PATCH',
        //         body: {
        //             ...initialpromptData,
        //         }
        //     }),
        //     invalidatesTags: (result, error, arg) => [
        //         { type: 'prompt', id: arg.id }
        //     ]
        // }),
        deleteChatKonv: builder.mutation({
            query: ({ id }) => ({
                url: `/chatKonv`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'chatKonv', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetChatKonvQuery,
    // useGetOnepromptQuery,
    // useGetAllpromptNamesQuery,
    // useGetpromptOrganizacijeByJmbgQuery,
    // useAddNewpromptMutation,
    // useUpdatepromptMutation,
    useDeleteChatKonvMutation,
} = chatKonvApiSlice

// returns the query result object
// export const selectpromptsResult = chatKonvApiSlice.endpoints.getprompts.select()

// creates memoized selector
// const selectpromptsData = createSelector(
//     selectpromptsResult,
//     promptsResult => promptsResult.data // normalized state object with ids & entities
// )

//getSelectors creates these selectors and we rename them with aliases using destructuring
// export const {
//     selectAll: selectAllprompts,
//     selectById: selectpromptById,
//     selectIds: selectpromptIds
//     // Pass in a selector that returns the prompts slice of state
// } = chatKonvAdapter.getSelectors(state => selectpromptsData(state) ?? initialState)